import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Params} from '@angular/router';
import {AuthenticationService, SocialLoginService} from '../../_services';
import {environment} from '../../../environments/environment';
import {Constants} from '../../shared/Helpers/constants';
import { SocialProviderNameEnum } from 'src/app/enums/enums';

@Component({
  selector: 'app-twitter-callback',
  templateUrl: './twitter-callback.component.html'
})
export class TwitterCallbackComponent implements OnInit {
  public success: boolean;
  public returnUrl: string;

  constructor(
    private route: ActivatedRoute,
    private socialLoginService: SocialLoginService,
    public authenticationService: AuthenticationService
  ) {
  }

  ngOnInit() {
    let code: any;
    let state: any;
    this.route.queryParams.subscribe((res: Params) => {
      code = res.code;
      state = res.state;
    });

    this.socialLoginService.getSocialInvitationSignUpOAuthCallback(SocialProviderNameEnum.Twitter, code, state).subscribe((res: any) => {
      const body = res.body;
      if (body.token) {
        this.returnUrl = environment.default_return_url;
        localStorage.setItem(Constants.localStorage_currentUser, JSON.stringify(body.token));
        this.authenticationService.redirect(this.returnUrl);
      }
    });
  }

}
